export default __webpack_public_path__ + "media/media.ce5b145b.jpg";